import { PciProxyCardNumber as BasePciProxyCardNumber } from '@mews/framework/payments';
import { createPciProxyField } from '../../utils/createPciProxyField';

// @ts-expect-error $TSFixMeError: Argument of type 'typeof PciProxyCardNumber' is not assignable to parameter of type 'ComponentType<{}>'.
export const PciProxyCardNumber = createPciProxyField(BasePciProxyCardNumber);
